module.exports = __webpack_public_path__ + "img/营销伙伴07.27868886.png";